export default __webpack_public_path__ + "static/media/logo-full.951f4498.svg";